import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaLocalizacion from "../vistas/vista_localizacion";
import FormLocalizacion from "../formularios/form_localizacion";

export default class DesplegableLocalizacion extends Component {
  render() {
    return (
      <Desplegable
        eventKey="2"
        id="2"
        Toogle="Localización"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalArray[2]}
        Text={<VistaLocalizacion DatosProvincia={this.props.state.DatosProvincia}></VistaLocalizacion>}
        Form={
          <FormLocalizacion
            DatosProvincia={this.props.state.DatosProvincia}
            setInformacionOrganismo={this.props.setInformacionOrganismo}
            handleButtonShow={this.props.handleButtonShow}
            nullField={this.props.nullField}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormLocalizacion>
        }
        canEdit={true}
      />
    );
  }
}
